import { Drawer, DrawerBody, DrawerFooter, DrawerOverlay, DrawerContent, useDisclosure, Flex, Text, Icon, Textarea, useToast } from '@chakra-ui/react'
import React from 'react'
import { AiFillPlusCircle, AiOutlineArrowLeft } from 'react-icons/ai'
import { Button } from '../../../../../../components/Button'
import { onUpdateObservacoes } from '../../../../GerarPedido/functions/updateObservacoes'
import { useMutation } from 'react-query'
import { useForm } from 'react-hook-form'

export function DetalhesDaProposta({ infoProposta }) {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const btnRef = React.useRef()

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm()

    const toast = useToast({
        position: 'top-right',
        duration: 3000,
        isClosable: true,
    })

    const { mutateAsync, isLoading: loading } = useMutation({
        mutationFn: onUpdateObservacoes,
        onSuccess: () => {
            toast({
                title: 'Observações atualizadas com sucesso',
                status: 'success',
            })

            onClose()
        },
        onError: (error) => {
            toast({
                title: 'Erro ao atualizar observações',
                description: error.message,
                status: 'error',
            })
        },
    })

    async function onSubmit(data) {
        await mutateAsync(data)
    }

    return (
        <>
            <Flex justifyContent="space-between" alignItems="center" onClick={onOpen} cursor="pointer" maxW="190px">
                <Text>Detalhes da proposta</Text>
                <Icon as={AiFillPlusCircle} color="#378BBF" fontSize="20px" />
            </Flex>

            <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={btnRef}>
                <DrawerOverlay />
                <DrawerContent minH="100vh">
                    <Text bgColor="#378BBF" textAlign="center" color="#F5F5F5" textTransform="uppercase" py="14px" fontWeight="semibold">
                        Detalhes da proposta
                    </Text>

                    <DrawerBody w="100%" display="flex" alignItems="center" justifyContent="center">
                        <Flex maxW="600px" flexDir="column" w="full" justifyContent="center" alignItems="center" gap={2} as="form" onSubmit={handleSubmit(onSubmit)}>
                            <input type="hidden" {...register('numero_nota')} value={infoProposta.num_proposta} />
                            <Textarea
                                borderRadius="0"
                                bgColor={'#F5F5F5'}
                                _hover={{ borderColor: '#F5F5F5' }}
                                _focus={{ borderColor: '#F5F5F5' }}
                                borderColor={'#F5F5F5'}
                                my={2}
                                maxW="600px"
                                placeholder="Detalhes da proposta"
                                resize="none"
                                // disabled={dadosPedido.aprovacao_pedido}
                                rows={10}
                                {...register('observacao_proposta')}
                                isInvalid={!!errors.observacao_proposta}
                                errorBorderColor="red.300"
                            />
                            <Button mr="auto" type="submit" isLoading={loading} loadingText="Atualizando...">
                                Atualizar detalhes da proposta
                            </Button>
                        </Flex>
                    </DrawerBody>

                    <DrawerFooter position="sticky" mt="auto" bottom="0" boxShadow="0px 3px 6px rgba(0, 0, 0, 0.635)">
                        <Flex alignItems="center" justifyContent="end" w="100%">
                            <Button maxW="181px" w="100%" fontSize="15px" fontWeight="semibold" bgColor="transparent" color="#FFA200" border="1px solid #FFA200" onClick={onClose}>
                                <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
                                Voltar
                            </Button>
                        </Flex>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
        </>
    )
}
